var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentTime)?_c('span',{staticClass:"timer"},[_vm._v(_vm._s(_vm.currentTime))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }